import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import UIList from 'UIComponents/list/UIList';
import FileAttachment from '../../files/FileAttachment';
import { useFetchBatchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { isError, isLoading } from 'reference-resolvers-lite/Status';
import styled from 'styled-components';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { useMemo } from 'react';
import FileValuesUnresolvedList from '../../files/values/FileUnresolvedValuesList';
import { getMissingReferences } from '../../files/utils';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFileAttachment = styled(FileAttachment).withConfig({
  displayName: "FormattedPropertyFiles__StyledFileAttachment",
  componentId: "sc-14uccrk-0"
})(["padding-left:0px;"]);
const FormattedPropertyFiles = props => {
  const propertyValue = usePropertyValue();
  const {
    placeholder,
    resolver
  } = props;
  const fileIds = parseMultiEnumValue(propertyValue);
  const {
    references: fileReferences,
    status
  } = useFetchBatchResolver(resolver, fileIds);
  const missingReferences = useMemo(() => isError(status) ? fileIds : getMissingReferences(fileReferences, fileIds), [fileIds, fileReferences, status]);
  if (isLoading(status)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "extra-small"
    });
  }
  const emptyFileReferences = !fileReferences || fileReferences.length === 0;
  if (emptyFileReferences && missingReferences.length === 0) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: placeholder
    });
  }
  const {
    className
  } = props;
  return /*#__PURE__*/_jsxs("span", Object.assign({
    className: className
  }, getDataAttributes(props), {
    children: [/*#__PURE__*/_jsx(UIList, {
      children: fileReferences && fileReferences.map(fileReference => /*#__PURE__*/_jsx(StyledFileAttachment, {
        fileReference: fileReference
      }, fileReference.id))
    }), missingReferences.length > 0 && /*#__PURE__*/_jsx(FileValuesUnresolvedList, {
      missingFileReferences: missingReferences,
      isEditDisabled: true,
      showRemoveAction: false
    })]
  }));
};
export default FormattedPropertyFiles;